import {HttpClient} from "@angular/common/http";
import {inject, Service} from "@angular/core";
import {Serialize} from "dcerialize";
import type {Observable} from "rxjs";
import {map} from "rxjs";
import {ContactForm} from "../../models/ContactForm/ContactForm";
import {BaseApiService} from "./base-api.service";

@Service()
export class ContactFormService extends BaseApiService {
  private readonly http = inject(HttpClient);

  public constructor() {
    super("contact-form");
  }

  // eslint-disable-next-line @typescript-eslint/prefer-readonly-parameter-types
  public submit(form: Readonly<ContactForm>): Observable<void> {
    return this.http.post(this.getEndpointUrl("send"), Serialize(form, () => ContactForm), {
      observe: "response",
      responseType: "blob",
      // eslint-disable-next-line @typescript-eslint/no-empty-function
    }).pipe(map(() => {
    }));
  }
}
